import { sharedTypes } from '@/shared/Constants';

import type { Event, UserData, UserSettings } from '@/shared/types';

type TranslationsInstance = (...args: any[]) => unknown;

interface GetUserDataOptions {
	skipOnboardingCheck?: boolean;
}

export function getUserDataRequest(options?: GetUserDataOptions) {
	return {
		type: sharedTypes.GET_USER_DATA_REQUEST,
		payload: {
			options,
		},
	};
}

export function getUserDataSuccess(userData: UserData) {
	return {
		type: sharedTypes.GET_USER_DATA_SUCCESS,
		payload: {
			userData,
		},
	};
}

export function getUserDataError(error?: unknown) {
	return {
		type: sharedTypes.GET_USER_DATA_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function logout(route?: string) {
	return {
		type: sharedTypes.LOGOUT,
		payload: { route },
	};
}

export function updateUserDataRequest(data: Record<string, unknown>) {
	return {
		type: sharedTypes.UPDATE_USER_DATA_REQUEST,
		payload: {
			data,
		},
	};
}

export function updateUserDataSuccess() {
	return {
		type: sharedTypes.UPDATE_USER_DATA_SUCCESS,
	};
}

export function updateUserDataError(error?: unknown) {
	return {
		type: sharedTypes.UPDATE_USER_DATA_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function clearUserData() {
	return {
		type: sharedTypes.CLEAR_USER_DATA,
	};
}

export function sendEventRequest(data?: Event) {
	return {
		type: sharedTypes.SEND_EVENT_REQUEST,
		payload: { data },
	};
}

export function sendEventSuccess(data?: Record<string, unknown>) {
	return {
		type: sharedTypes.SEND_EVENT_SUCCESS,
		payload: { data },
	};
}

export function sendEventError() {
	return {
		type: sharedTypes.SEND_EVENT_ERROR,
	};
}

export function setTranslationsInstance(translationsInstance: TranslationsInstance) {
	return {
		type: sharedTypes.SET_TRANSLATIONS_INSTANCE,
		payload: { translationsInstance },
	};
}

export function setBackgroundColor(backgroundColor: string | null) {
	return {
		type: sharedTypes.SET_BACKGROUND_COLOR,
		payload: { backgroundColor },
	};
}

export function setBackgroundPattern(backgroundPattern: string | null) {
	return {
		type: sharedTypes.SET_BACKGROUND_PATTERN,
		payload: { backgroundPattern },
	};
}

export function toggleMobileFooterMenu(openMobileFooterMenu: boolean) {
	return {
		type: sharedTypes.TOGGLE_MOBILE_FOOTER_MENU,
		payload: { openMobileFooterMenu },
	};
}

export function handleUserExperiment(experimentName: string) {
	return {
		type: sharedTypes.HANDLE_USER_EXPERIMENT,
		payload: { experimentName },
	};
}

export function handleUserExperimentSuccess(experimentName: string) {
	return {
		type: sharedTypes.HANDLE_USER_EXPERIMENT_SUCCESS,
		payload: { experimentName },
	};
}

export function toggleGeneralFeedbackForm(openGeneralFeedbackForm: boolean) {
	return {
		type: sharedTypes.TOGGLE_GENERAL_FEEDBACK_FORM,
		payload: { openGeneralFeedbackForm },
	};
}

export function updateUserDataSettings(settings: UserSettings) {
	return {
		type: sharedTypes.UPDATE_USER_DATA_SETTINGS,
		payload: { settings },
	};
}
